module.exports = __webpack_public_path__ + "img/icon-add-primary.43213db1.svg";